import { render, staticRenderFns } from "./ContentHealth.vue?vue&type=template&id=2d01f3a4"
import script from "./ContentHealth.vue?vue&type=script&lang=js"
export * from "./ContentHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports